import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import Button from "../../compopnents/button";
import PopupMenu from "../../compopnents/popupmenu";
import { BreadcrumbLinkMouseEvent, DataModel } from "@progress/kendo-react-layout";
import classnames from "classnames";
import Breadcrumbs from "../../compopnents/breadCrumbs";
import SearchBar from "../../compopnents/searchbar";
import ResourceFilter from "../../modal/resourcefilter";
import TimeSheetFilter from "../../modal/timeSheetFilter";
import { checkPriority, priorityClass ,  checkTimesheetStatus } from "../../utils/ellowutils";
import DashboardFilter from "../../modal/dashboardFilter";

interface Props {
  title: any;
  navigateTo?: any;
  searchChange: any;
  popupMenu?: boolean;
  jobId?: string;
  candidateLoginId?: string;
  updatePosition?: any;
  onClick?: any;
  filterNumber?: any;
  filterValues?: any;
  closeTag?: any;
  type?: string;
  companyList?: any;
  allocatedTo?: any;
  applyFilter?: any;
  applyResourceFilter?:any;
  applyCompanyFilter?:any;
  positionName?: any;
  jobStatus?: number;
  companyName?: any;
  priority?: any;
  applyDashboardFilter?: any;
  name?: any;
  NoSettingsIcon?: any;
  timesheetStatus?: any;
  role?: any;
}

const DashboardHeader: React.FC<Props> = ({
  navigateTo,
  popupMenu,
  title,
  searchChange,
  type,
  priority,
  jobStatus,
  filterNumber,
  filterValues,
  updatePosition,
  applyFilter,
  applyDashboardFilter,
  name,
  closeTag,
  NoSettingsIcon,
  timesheetStatus,
  companyName,
  role
}) => {

  const navigate = useNavigate();
  const [resourceFilter, setResourceFilter] = useState<boolean>(false)
  const [filter, setFilter] = useState<boolean>(false)
  const [timeSheetFilter, setTimeSheetFilter] = useState<boolean>(false)
  const [defaultValues, setDefaultValues] = useState<any>()

  const settings = () => {
  
  }

  const onselect = (event: BreadcrumbLinkMouseEvent) => {
    if (event.id === 'Positions') {      
      navigate('../positions')
    }
     if (event.id === 'Contract Resources') {      
      navigate('../contractresources')
    } 
    if (event.id === 'settings') {      
      navigate('../company')
    }  
  }

  const headerNavigation = () => {
    navigate(navigateTo) 
  }

  let item: DataModel[] = title && title.map((item: any, key: number) => {
    return {
      id: key + 1,
      text: item,
    }
  })

  const clickHandler = (data: any, name:string) => {    
    
    if (name === 'timeSheet') {       
     applyFilter(data)
   }
  }

  const onClick = (type: string) => {
    switch (type) {
      case 'timeSheet':
        setTimeSheetFilter(true)
        return
    }
  }
 
      
  return (
    <div className={Styles.dashHead}>
      <div className={Styles.mobileHead}>
        {/* <button className={Styles.back}>back</button> */}
        <h3>
          {title !== false &&
            <div>
              <Breadcrumbs data={item} onItemSelect={onselect} />
              <span>{name}</span>
            </div>   
          }
          {title == false &&
            <div className={Styles.roleHeadWrap}>
              <div className={Styles.rolehead}>{name} - <span>{role} @ {companyName}</span></div>
              <div className={checkTimesheetStatus(timesheetStatus).class}>
                {checkTimesheetStatus(timesheetStatus).value}
              </div>
            </div>
          }
        </h3> 
        {navigateTo && (
          <Button onClick={headerNavigation} variant="primary" size="small">
            {navigateTo === "../applyPositions"
              ? "Apply for this Position"
              : "Add New"}
          </Button>
        )} 
        {priority && <div className={classnames("headWithLabel", Styles.headWithLabel)}><label className={priorityClass(priority) }>{checkPriority(priority)}</label></div>}
        {popupMenu && (
          <PopupMenu>
            <div className={Styles.popupLinks}>
              { jobStatus !== 3 && <Link to="" onClick={() => updatePosition('edit')}><Icon icon="lucide:edit-2"/>Edit</Link>}
              <Link to="" onClick={() => updatePosition( jobStatus === 3 ? 'reopen' : 'close')}><Icon icon="ep:circle-close" />{jobStatus === 3 ? 'Reopen Position' : 'Close Position'}</Link>
              <Link to="" className={Styles.danger} onClick={() => updatePosition('delete')} ><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
            </div>
          </PopupMenu>
        )}
        {/* {popupMenu && (
          <PopupMenu>
            <div className={Styles.popupLinks}>
              <Link to="" onClick={() => ''}><Icon icon="lucide:edit-2"/>Edit</Link>
              <Link to="" onClick={() => ''}><Icon icon="ep:circle-close" />Close</Link>
              <Link to="" className={Styles.danger} onClick={() => ''} ><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
            </div>
          </PopupMenu>
        )} */}
      </div>
      {searchChange && <SearchBar type={type}  onClick={onClick}  searchChange={searchChange} filterNumber={filterNumber} filtervalues={filterValues} tagClose={(data: any) => { closeTag(data); setDefaultValues(data) }}/>}
      <div className={Styles.notiWithSort}>
        { type === 'dashboard' && <DashboardFilter applyDashboardFilter={applyDashboardFilter}/>}
        {!NoSettingsIcon &&
          <div className={Styles.notification}>
            {/* <Link to="/help">
              <Icon icon="charm:help" />
            </Link> */}
            <Link to="/companysettings" onClick={settings}>
              <Icon icon="tabler:settings" />
            </Link>
            {/* <Link to="#">
              <Icon icon="iconoir:bell" />
            </Link> */}
          </div>
        }
      </div>
      {/* {filter && <PositionFilter onClose={() => setFilter(false)} ClickHandler={(data: any) => { clickHandler(data,'positions'); setFilter(false)}} companyList={companyList} allocatedTo={allocatedTo} positionName={positionName} defaultValues={filterValues} />} */}
      {/* {resourceFilter && <ResourceFilter onClose={() => setResourceFilter(false)} />} */}
      {timeSheetFilter && <TimeSheetFilter onClose={() =>  setTimeSheetFilter(false)} ClickHandler={(data: any) => { clickHandler(data,'timeSheet'); setTimeSheetFilter(false)}} defaultValues={filterValues}/>}
    </div>
  )
}

export default DashboardHeader;
